// Locale handling for the patient/clinician report so the generated PDF can be
// rendered in the patient's language. Mirrors the backend locale set
// (runecore.translations.SUPPORTED_LOCALES) and normalization rules so a locale
// resolved server-side maps to the same catalog here.

export const FALLBACK_LOCALE = 'en'

export const SUPPORTED_LOCALES = [
  'en',
  'es',
  'es_ES',
  'fr_CA',
  'ja',
  'nl',
  'sv',
]

// Normalize an incoming locale (e.g. from the `locale` query param or an
// Accept-Language-style value) to one of SUPPORTED_LOCALES, falling back to
// English. Matches the backend behavior: any French regional variant maps to
// fr_CA, exact regional variants we support are preserved, and otherwise we
// fall back to the base language subtag.
export const normalizeLocale = (rawLocale) => {
  if (!rawLocale) {
    return FALLBACK_LOCALE
  }

  const locale = String(rawLocale).trim().replace('-', '_')

  if (locale.toLowerCase().startsWith('fr')) {
    return 'fr_CA'
  }

  const exactMatch = SUPPORTED_LOCALES.find(
    (supported) => supported.toLowerCase() === locale.toLowerCase(),
  )
  if (exactMatch) {
    return exactMatch
  }

  const baseSubtag = locale.split('_')[0].toLowerCase()
  if (SUPPORTED_LOCALES.includes(baseSubtag)) {
    return baseSubtag
  }

  return FALLBACK_LOCALE
}
